let css = require('./purpose-tree.css');
let filterableTreeFactory = require('../../../filterable-tree');
let purposes = require('../../../../../../signals/custom-order/purposes');

class Discount {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        let props = this.$context.props;
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, props, { css }));
    }
}

module.exports = {
    constructor: Discount,
    children: [
        {
            name: 'purpose-tree',
            component: filterableTreeFactory({
                basePath: ['order', 'addParams', 'purposes', 'tree']
            }),
            watcher: {
                isDisabled: ['order', 'isDisabled']
            },
            props: {
                id: 'purposes',
                onItemCheck: purposes.onItemCheck,
                onSetAll: purposes.onSetAll,
                minFilterLength: 2,
                isInnerTree: true
            },
            parentPropsMap: {
                isSmallTree: 'isSmallTree'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/common/custom-order/additional-parameters/content/purpose-tree/index.js